import { Component, HostListener, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DialogService } from "src/app/services/dialog.service";
import { GetInformacionService } from "../../services/perfilamiento/get-informacion.service";
import { DataService } from "src/app/services/data.service";

@Component({
  selector: "app-registro-correo",
  templateUrl: "./registro-correo.component.html",
  styleUrls: ["./registro-correo.component.scss"],
})
export class RegistroCorreoComponent implements AfterViewInit {
  public formInfoCorreo: FormGroup;
  loading = false;
  intentosContinuar = 0;
  private correoGuardado: string | null = null;

  constructor(
    private router: Router,
    private dialogServ: DialogService,
    private data: DataService,
    private getinfoServ: GetInformacionService
  ) {
    this.formInfoCorreo = new FormGroup({
      correo: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.pattern(
          /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
        ),
      ]),
      confirmarCorreo: new FormControl("", [
        Validators.required,
        this.correoIgualValidator.bind(this),
      ]),
    });

    this.formInfoCorreo
      .get("correo")
      ?.valueChanges.subscribe(() =>
        this.formInfoCorreo.get("confirmarCorreo")?.updateValueAndValidity()
      );
  }

  @HostListener("paste", ["$event"])
  blockPaste(e: ClipboardEvent) {
    this.dialogServ.openDialog(
      "Función no permitida",
      "Ingresa manualmente el correo electrónico",
      false
    );
    e.preventDefault();
  }

  @HostListener("copy", ["$event"])
  blockCopy(e: ClipboardEvent) {
    this.dialogServ.openDialog(
      "Función no permitida",
      "No es permitido copiar el contenido seleccionado",
      false
    );
    e.preventDefault();
  }

  @HostListener("cut", ["$event"])
  blockCut(e: ClipboardEvent) {
    this.dialogServ.openDialog(
      "Función no permitida",
      "No es permitido cortar el contenido seleccionado",
      false
    );
    e.preventDefault();
  }

  ngAfterViewInit(): void {
    this.data.isResume = false;
  }

  /** Validación custom para confirmar correo */
  correoIgualValidator(control: FormControl) {
    if (!this.formInfoCorreo) return null;
    const correo = this.formInfoCorreo.get("correo")?.value;
    return correo === control.value ? null : { emailsNoCoinciden: true };
  }

  /** Paso 1: confirmación del correo */
  confirmacion() {
    if (this.intentosContinuar > 0) return;

    this.intentosContinuar = 1;
    const correo = this.formInfoCorreo.get("correo")?.value;

    this.dialogServ.openDialog(
      "Confirmación",
      `¿Estás seguro que <strong>${correo}</strong> es el correo electrónico que deseas registrar?`,
      false,
      "Sí, guardar",
      () => {
        this.correoGuardado = correo;
        console.log("Correo guardado:", this.correoGuardado);
        this.intentosContinuar = 0;

        // Paso 2: usar tu nuevo diálogo para elegir canal
        setTimeout(() => this.savemail(), 3000);
      },
      true,
      "No, ajustar",
      () => {
        this.intentosContinuar = 0;
      }
    );
  }

  /** Paso 2: nuevo diálogo para elegir canal de validación */
  savemail(): void {
    if (!this.correoGuardado) {
      console.warn("No hay correo registrado para enviar validación.");
      return;
    }

    this.dialogServ.openDialog(
      "Selecciona el medio de validación",
      "Elige el medio por el cual el cliente desea recibir la verificación para validación de identidad.",
      true,
      "Mensaje whatsapp",
      () => this.enviarValidacion("whatsapp"),
      true,
      "Código sms",
      () => this.enviarValidacion("otp")
    );
  }

  /** Envía la petición según canal */
  private enviarValidacion(medio: "whatsapp" | "otp"): void {
    if (this.intentosContinuar > 0) return;

    this.loading = true;
    this.intentosContinuar = 1;
    const esNuevo = this.correoGuardado === "Ninguna de los anteriores";
    const ind = esNuevo ? 0 : 1;

    this.getinfoServ
      .saveCascadaMail({
        ind,
        correo: this.correoGuardado!,
        carpeta: this.data.numeroCarpeta.toString(),
        cedula: this.data.cedula.toString(),
        medio,
      })
      .subscribe(
        (resp) => {
          console.log("respuesta API:", resp);
          this.data.isNewEmail = esNuevo;
          this.router.navigateByUrl("/" + resp.data.ruta);
        },
        (err) => {
          console.error("Error al enviar validación:", err);
          this.dialogServ.openDialog(
            "Error",
            err.error?.message || "Ocurrió un error inesperado",
            false,
            "Volver a intentar"
          );
          this.loading = false;
          this.intentosContinuar = 0;
        }
      );
  }
}